var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00002 1.1665C3.78002 1.1665 1.16669 3.77984 1.16669 6.99984C1.16669 10.2198 3.78002 12.8332 7.00002 12.8332C10.22 12.8332 12.8334 10.2198 12.8334 6.99984C12.8334 3.77984 10.22 1.1665 7.00002 1.1665ZM7.00002 11.6665C4.42752 11.6665 2.33335 9.57234 2.33335 6.99984C2.33335 4.42734 4.42752 2.33317 7.00002 2.33317C9.57252 2.33317 11.6667 4.42734 11.6667 6.99984C11.6667 9.57234 9.57252 11.6665 7.00002 11.6665ZM9.67752 4.4215L5.83335 8.26567L4.32252 6.76067L3.50002 7.58317L5.83335 9.9165L10.5 5.24984L9.67752 4.4215Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.271a1fae3a60f98ece1a24444cfa1227.svg";
export { ForwardRef as ReactComponent };